import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { staggerContainer, itemVariants } from '../utils/animations';
const testimonials = [{
  name: 'Martín S.',
  business: 'Clínica Odontológica',
  quote: '"Nuestras reservas online aumentaron un 40% en el primer mes. La web transmite exactamente la higiene y profesionalismo que queríamos."',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=90&w=200'
}, {
  name: 'Valentina R.',
  business: 'Restaurante de Autor',
  quote: '"Parece la web de un restaurante con estrellas Michelin. El diseño elegante hace que las fotos de nuestros platos resalten increíblemente."',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=90&w=200'
}, {
  name: 'Diego M.',
  business: 'Hotel Boutique',
  quote: '"En 72hs teníamos una web que superaba a la de hoteles internacionales. Dejamos de depender tanto de Booking y aumentamos reservas directas."',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=90&w=200'
}];
export function Testimonials() {
  return <section className="py-20 md:py-32 relative" data-id="element-343">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-344">
        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-345">
          {testimonials.map((test, idx) => <motion.div key={idx} variants={itemVariants} className="p-6 sm:p-8 rounded-2xl bg-white/[0.02] border border-white/5 flex flex-col justify-between" data-id="element-346">
              <div data-id="element-347">
                <div className="flex space-x-1 mb-6" data-id="element-348">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-neon fill-neon drop-shadow-[0_0_5px_rgba(59,130,246,0.5)]" data-id="element-349" />)}
                </div>
                <p className="text-lg text-neutral-300 font-light leading-relaxed mb-8" data-id="element-350">
                  {test.quote}
                </p>
              </div>
              <div className="flex items-center space-x-4" data-id="element-351">
                <img src={test.avatar} alt={test.name} className="w-11 h-11 rounded-full object-cover ring-2 ring-white/10 shadow-md" loading="lazy" data-id="element-352" />
                <div data-id="element-353">
                  <div className="text-white font-medium" data-id="element-354">{test.name}</div>
                  <div className="text-neutral-500 text-sm" data-id="element-355">
                    {test.business}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}